import {
  componentNameConstants,
  dlElementConstants,
  dlEventConstants,
} from "@repo/analytics/data-layer.constants";
import { dataLayer } from "@repo/analytics/data-layer-utils";

/**
 * Logs "Go To Top" button click event in the footer.
 */
export const handleBackToTopDL = (loginStatus: string, cta_text: string) => {
  const data = {
    component: componentNameConstants.FOOTER_COMPONENT,
    event: dlEventConstants.CLICK,
    event_type: dlEventConstants.BUTTON_CLICK,
    element: dlElementConstants.FOOTER_GO_TO_TOP,
    cta_text,
  };

  const cleverTapObj = {
    component: data.component,
    event: data.event,
    event_type: data.event_type,
    element: data.element,
    cta_text: data.cta_text,
  };

  dataLayer(loginStatus, data, cleverTapObj);
};
